import React, { Component } from "react";
import Slider from "react-slick";

const imgSlide = [
  {
    name: "photo 1",
    url: "/images/slide1.jpg",
  },
  {
    name: "photo 2",
    url: "/images/slide2.jpg",
  },
  {
    name: "photo 3",
    url: "/images/slide3.jpg",
  },
  {
    name: "photo 4",
    url: "/images/slide4.jpg",
  },
];
function SlideBanner() {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };
  return (
    <div className="slideBanner">
      <Slider {...settings}>
        {imgSlide.map((photo) => {
          return (
            <div>
              <img className="img-fluid" src={photo.url} alt="" />
            </div>
          );
        })}
      </Slider>
    </div>
  );
}
export default SlideBanner;
